<div [softMetaControlName]="name()">
  <soft-meta-label></soft-meta-label>
  <ng-content></ng-content>
</div>
